export default __webpack_public_path__ + "static/media/instagram-logo.232b6d8f.svg";